import { useMediaQuery, useTheme } from "@mui/material";

export function useBreakpoint() {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("sm"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    return { isXs, isDesktop };
}
